import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { PrivacyPolicyEn } from './PrivacyPolicyEn';
import { PrivacyPolicyPt } from './PrivacyPolicyPt';

const PrivacyPolicy = () => {
  const { i18n } = useTranslation();
  const isPt = i18n.language.startsWith('pt');

  return (
    <>
      <Helmet>
        <title>Privacy Policy — Dont Tab</title>
        <meta
          content="Learn how Dont Tab collects, uses, and protects your personal information. Read our privacy policy."
          name="description"
        />
        <link href="https://donttab.com/privacy" rel="canonical" />
        <meta content="Privacy Policy — Dont Tab" property="og:title" />
        <meta content="https://donttab.com/privacy" property="og:url" />
      </Helmet>
      {isPt ? <PrivacyPolicyPt /> : <PrivacyPolicyEn />}
    </>
  );
};

export default PrivacyPolicy;
